import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  emailValidation,
  getPhoneNumberLimits,
  handlePhoneNoChange,
  nameValidation,
  phoneNumberValidation,
} from "../../Common/Validations";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { Loader } from "../../Common/Loader";
import defaultimage from "../../Assets/images/VoxApp-Icon.png";
import { debounce } from "../../Common/debounce";
import { getStateFromZipcode } from "../../Redux/Slice/Common/GetStateFromZipcode";
import { CreateContact } from "../../Redux/Slice/Contacts/CreateContactSlice";
import { getContactById } from "../../Redux/Slice/Contacts/GetContactByIdSlice";
import { UpdateContact } from "../../Redux/Slice/Contacts/UpdateContactSlice";
import ImageIcon from "../../Assets/images/VoxApp-Icon.png";
import useDebounce from "../../Common/useDebounce";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { ALL_CALLING_CODES } from "../../Common/Constants";
import { copyToClipboard, maskNoByCallingCode } from "../../Common/utils";
import CountryPhoneInput from "../../Common/CountryPhoneInput";
import CopyIcon from "../../Assets/svgs/CopyIcon";
import CopyBox from "../../Common/CopyBox";

export const AddContact = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    countryCallingCode: "+61",
    address: {
      address: "",
      pincode: "",
      state: "",
      city: "",
      country: "",
    },
  });
  const [formError, setFormError] = useState({
    emailError: "",
    phoneError: "",
    firstNameError: "",
    lastNameError: "",
  });
  const [isEditForm, setEditForm] = useState(false);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setCOnfirmModel] = useState("");
  const [hasChanged, setHasChanged] = useState(false);
  const [hasChangedModel, setHasChangedModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const [pinCOde, setPincode] = useState("");
  const debouncedZipCode = useDebounce(pinCOde, 500);
  const [imageData, setImageData] = useState();
  const [image, setImage] = useState();
  const getCOntactDetails = async (id) => {
    setIsLoading(true);
    const result = await dispatch(getContactById(id));
    if (
      getContactById.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      const data = result.payload.data;
      if (data.avatar) {
        setImageData(data.avatar);
      }
      setFormData({
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phoneNumber: data?.phoneNumber ? data?.phoneNumber : "",
        countryCallingCode: data?.countryCallingCode
          ? data?.countryCallingCode
          : "+91",
        address: {
          address: data.address?.address,
          city: data.address?.city,
          state: data.address?.state,
          country: data.address?.country,
          zipcode: data.address?.zipCode,
        },
      });
      setPincode(data.address?.zipCode);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    if (props.contactId) {
      setEditForm(true);
      getCOntactDetails(props.contactId);
    }
  }, [props?.contactId]);

  const handleChange = async (e) => {
    let { name, value } = e.target;
    value = value.trimStart();
    dispatch(setUnsavedChanges(true));
    setHasChanged(true);
    if (name === "email") {
      value = value.trimEnd();
      const isValid = emailValidation(value);
      setFormData({ ...formData, [name]: value.trimStart() });
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, emailError: "" });
      } else {
        setFormError({ ...formError, emailError: "Please enter valid Email" });
      }
    } else if (name === "firstName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, firstNameError: "" });
      } else {
        setFormError({
          ...formError,
          firstNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else if (name === "lastName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, lastNameError: "" });
      } else {
        setFormError({
          ...formError,
          lastNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else {
      //need to debug here

      if (name === "address") {
        setFormData({
          ...formData,
          address: {
            address: value,
          },
        });
      } else {
        setFormData({ ...formData, [name]: value });
      }
    }
  };

  const handleChangeImage = (e) => {
    if (e.target.files?.length > 0) {
      dispatch(setUnsavedChanges(true));
      setHasChanged(true);
      setImage(e.target.files[0]);
      setImageData(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleCountryCodeChange = async (e) => {
    const { name, value } = e.target;
    dispatch(setUnsavedChanges(true));
    setHasChanged(true);
    let formatted = formData?.phoneNumber;
    setFormData({ ...formData, [name]: value, phoneNumber: formatted });
    const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
    const rawDigits = formData.phoneNumber.replace(/\D/g, "");
    const isValid = phoneNumberValidation(rawDigits, value);
    setFormError({
      ...formError,
      phoneError:
        isValid || value === ""
          ? ""
          : rawDigits.length < minDigits
          ? `Phone number must be at least ${minDigits} digits long.`
          : "Please enter a valid phone number",
    });
  };

  const handlePhoneChange = async (e) => {
    let { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    handlePhoneNoChange(
      e,
      formData.countryCallingCode,
      (newValue) => {},
      (newError) => setFormError({ ...formError, phoneError: newError }),
      (isChanged) => {
        dispatch(setUnsavedChanges(true));
        setHasChanged(isChanged);
      },
      false
    );
  };

  const handleUpdate = async () => {
    setCOnfirmModel(false);
    setIsLoading(true);
    let formData2 = new FormData();
    const body = {
      id: props.contactId,
      ...formData,
      phoneNumber: formData.phoneNumber.replace(/\D/g, ""),
    };
    formData2.append("file", image); // Append image to FormData
    formData2.append("body", JSON.stringify({ ...body }));
    const result = await dispatch(
      UpdateContact({
        id: props?.contactId,
        formData: formData2,
      })
    );
    if (
      UpdateContact.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      dispatch(setUnsavedChanges(false));
      setSuccessMessage("Contact updated Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate(-1);
      }, 1500);
    } else {
      //TODO: error popup here
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const handleClick = async () => {
    if (isEditForm) {
      setCOnfirmModel(true);
    } else {
      setIsLoading(true);
      let formData2 = new FormData();
      let body = {
        ...formData,
        phoneNumber: formData.phoneNumber.replace(/\D/g, ""),
      };
      if (location?.state?.contactGroupId) {
        body.contactGroupId = location?.state?.contactGroupId;
      }
      formData2.append("file", image); // Append image to FormData
      formData2.append("body", JSON.stringify({ ...body }));
      const result = await dispatch(CreateContact(formData2));
      if (
        CreateContact.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setIsLoading(false);
        dispatch(setUnsavedChanges(false));
        setSuccessMessage("Contact created Successfully!");
        setSuccessModel(true);
        setTimeout(() => {
          setSuccessModel(false);
          navigate(-1);
        }, 1500);
      } else {
        //TODO: error popup here
        setIsLoading(false);
        setErrorMessage(result?.payload?.error?.message);
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const handleCancel = () => {
    dispatch(setUnsavedChanges(false));
    navigate(-1);
  };

  const onCancelClicked = () => {
    if (hasChanged) {
      setHasChangedModel(true);
    } else {
      handleCancel();
    }
  };

  const getStateDetails = async (pincode) => {
    if (pincode > 0) {
      const result = await dispatch(getStateFromZipcode(pincode));
      if (
        getStateFromZipcode.fulfilled.match(result) &&
        result?.payload?.success === true
      ) {
        setFormData((prevData) => ({
          ...prevData,
          address: {
            ...prevData.address,
            country: result?.payload?.data?.country,
            city: result?.payload?.data?.city,
            state: result?.payload?.data?.state,
            zipCode: pincode,
          },
        }));
        setFormError({ ...formError, zipCodeError: "" });
      } else {
        setFormData((prevData) => ({
          ...prevData,
          address: {
            ...prevData.address,
            country: "",
            city: "",
            state: "",
            zipCode: pincode,
          },
        }));
        if (pinCOde.length === 5) {
          setFormError({
            ...formError,
            zipCodeError: "Invalid ZipCode",
          });
        }
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          country: "",
          city: "",
          state: "",
          zipCode: pincode,
        },
      }));
    }
  };
  const debouncedGeStateList = useCallback(debounce(getStateDetails, 500), [
    debouncedZipCode,
  ]);

  const handleChangeCustomerZipcode = async (e) => {
    const { name, value } = e.target;
    const formattedValue = value.replace(/\D/g, "");
    dispatch(setUnsavedChanges(true));
    setHasChanged(true);
    setPincode(formattedValue);
    debouncedGeStateList(formattedValue);
    if (formattedValue.length > 0 && formattedValue.length <= 5) {
      setFormError({
        ...formError,
        zipCodeError: "Invalid ZipCode",
      });
    } else {
      setFormError({ ...formError, zipCodeError: "" });
    }
  };

  return (
    <div className="page__body">
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {isLoading ? <Loader /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={handleUpdate}
          onReject={() => {
            setCOnfirmModel(false);
          }}
          title="Update Contact!"
          message="Are you sure you want to Update the contact?"
        />
      ) : (
        ""
      )}
      {hasChangedModel ? (
        <ConfirmModel
          onAccept={handleCancel}
          yes={"Yes"}
          no={"No"}
          onReject={() => {
            setHasChangedModel(false);
          }}
          title="Update Changes!"
          message="Changes made will not be saved. Are you sure you want to leave the page?"
        />
      ) : null}
      <div className="details">
        <div className="form">
          <section className="form__section">
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field form__Field--profileBox">
                  <label className="form__uploadProfile" for="uploadProfile">
                    <img
                      className="form__uploadProfile__picture"
                      src={imageData ? imageData : ImageIcon}
                    />

                    <span className="form__uploadProfile__edit">
                      <span className="icon">
                        <svg
                          width="11"
                          height="11"
                          viewBox="0 0 11 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.875 1.3797C7.99538 1.25932 8.13829 1.16383 8.29557 1.09868C8.45285 1.03353 8.62143 1 8.79167 1C8.96191 1 9.13048 1.03353 9.28776 1.09868C9.44505 1.16383 9.58796 1.25932 9.70833 1.3797C9.82871 1.50007 9.9242 1.64298 9.98935 1.80027C10.0545 1.95755 10.088 2.12612 10.088 2.29636C10.088 2.4666 10.0545 2.63518 9.98935 2.79246C9.9242 2.94974 9.82871 3.09265 9.70833 3.21303L3.52083 9.40053L1 10.088L1.6875 7.5672L7.875 1.3797Z"
                            stroke="white"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </span>
                  </label>
                  <input
                    type="file"
                    id="uploadProfile"
                    className="form__uploadfiled"
                    onChange={handleChangeImage}
                    accept="image/*"
                  />
                </div>
              </div>
              {props?.contactId ? (
                <div
                  className="formCol"
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-end",
                  }}
                >
                  <CopyBox text={props?.contactId} />
                </div>
              ) : null}
            </div>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="name" className="form__label">
                    First Name<span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="firstName"
                    maxLength={30}
                    value={formData.firstName}
                    onChange={handleChange}
                    className="form__input form__input--sm"
                    placeholder="First Name"
                  />
                </div>
                <div className="form__error">{formError.firstNameError}</div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="name" className="form__label">
                    Last Name<span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    maxLength={30}
                    id="name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="form__input form__input--sm"
                    placeholder="Last Name"
                  />
                </div>
                <div className="form__error">{formError.lastNameError}</div>
              </div>
            </div>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="email" className="form__label">
                    Email<span style={{ color: "red" }}> * </span>
                  </label>
                  <input
                    type="text"
                    id="email"
                    disabled={isEditForm}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    maxLength={100}
                    className={
                      isEditForm
                        ? "form__input form__input--sm form__input--disabled"
                        : "form__input form__input--sm"
                    }
                    placeholder="Email Address"
                  />
                </div>
                <div className="form__error">{formError.emailError}</div>
              </div>
              <div className="formCol">
                <div className="form__Field">
                  <label for="phonenumber" className="form__label">
                    Phone Number<span style={{ color: "red" }}> * </span>
                  </label>
                  <CountryPhoneInput
                    countryCodeFieldName="countryCallingCode"
                    phoneFieldName="phoneNumber"
                    countryCode={formData.countryCallingCode}
                    phoneNumber={formData.phoneNumber}
                    onCountryChange={handleCountryCodeChange}
                    onPhoneChange={handlePhoneChange}
                  />
                  <div className="form__error"> {formError.phoneError}</div>
                </div>
              </div>
            </div>
            <div className="formRow formRow__2">
              <div className="formCol">
                <div className="form__Field">
                  <label for="email" className="form__label">
                    Address
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="address"
                    maxLength={100}
                    onChange={handleChange}
                    value={formData.address.address}
                    className="form__input form__input--sm"
                    placeholder="Address"
                  />
                </div>
              </div>
              <div className="formRow formRow__4">
                <div className="formCol">
                  <div className="form__Field">
                    <label htmlFor="orgZipCode" className="form__label">
                      Zip Code
                    </label>
                    <input
                      type="text"
                      id="orgZipCode"
                      name="zipCode"
                      value={pinCOde}
                      onChange={handleChangeCustomerZipcode}
                      className="form__input form__input--sm"
                      placeholder="Zip Code"
                      maxLength={4}
                    />
                  </div>
                </div>
                <div className="formCol">
                  <div className="form__Field">
                    <label htmlFor="orgCity" className="form__label">
                      City
                    </label>
                    <input
                      type="text"
                      id="orgCity"
                      name="city"
                      disabled
                      value={formData?.address?.city}
                      onChange={handleChange}
                      className="form__input form__input--sm form__input--disabled"
                      placeholder="City"
                    />
                  </div>
                </div>
                <div className="formCol">
                  <div className="form__Field">
                    <label htmlFor="orgState" className="form__label">
                      State
                    </label>
                    <input
                      type="text"
                      id="orgState"
                      name="state"
                      disabled
                      value={formData?.address?.state}
                      onChange={handleChange}
                      className="form__input form__input--sm form__input--disabled"
                      placeholder="State"
                    />
                  </div>
                </div>
                <div className="formCol">
                  <div className="form__Field">
                    <label htmlFor="orgCountry" className="form__label">
                      Country
                    </label>
                    <input
                      type="text"
                      id="orgCountry"
                      name="country"
                      disabled
                      value={formData?.address?.country}
                      onChange={handleChange}
                      className="form__input form__input--sm form__input--disabled"
                      placeholder="Country"
                    />
                  </div>
                </div>
                <div className="form__error">{formError.zipCodeError}</div>
              </div>
            </div>
            <div className="btn__group">
              <button
                className="btn btn__white"
                onClick={onCancelClicked}
                type="button"
              >
                Cancel
              </button>
              <button
                className="btn btn__primary"
                onClick={handleClick}
                disabled={
                  !hasChanged ||
                  formData.firstName === "" ||
                  formError.firstNameError != "" ||
                  formData.lastName === "" ||
                  formError.lastNameError != "" ||
                  formData.email === "" ||
                  formError.emailError != "" ||
                  formData.phoneNumber === "" ||
                  formError.phoneError != "" ||
                  formError.zipCodeError
                }
                type="submit"
              >
                {isEditForm ? "Update" : "Save"}
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
